import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: ':groupId',
    name: 'users',
    props: true,
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    meta: {
      middleware: [loggedIn]
    },
    children: [
      {
        path: ':id',
        name: 'usersTableComponent',
        props: true,
        meta: {
          rootRouteName: 'users'
        },
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'users' }
  }
];
